module.exports = __webpack_public_path__ + "static/media/features-customized-full.97af83dc.png";